import { gsap } from 'gsap/all'
import { store } from '../../src/js/core/store.js'

export const initTeamGrid = () => {
  const members = [...document.querySelectorAll('.js-member')]
  if (members.length <= 0) { return false }

  let activeHover = null

  members.forEach(member => {
    const hoverInstance = new Hover(member, store.isDevice);
    member.addEventListener('mouseenter', () => hoverInstance.enter());
    member.addEventListener('mouseleave', () => hoverInstance.leave());
  })
}

class Hover {
  constructor (member, noTouch) {
    this.member = member
    this.overlay = member.querySelector('.js-overlay')
    this.title = member.querySelector('.js-title')
    this.children = [...member.querySelectorAll('.js-child')]
    this.showInfo = false
    this.noTouch = noTouch
    this.bind()
  }

  static setActiveHover(hoverInstance) {
    Hover.activeHover = hoverInstance;
  }

  enter = () => {
    if (Hover.activeHover && Hover.activeHover !== this) {
      Hover.activeHover.leave();
    }

    gsap.to(this.overlay, 0.5, {
      y: '0%',
      ease: 'expo.out',
      opacity: 1,
      onStart: () => {
        this.overlay.style.willChange = 'transform'
      },
      onComplete: () => {
        this.overlay.style.willChange = 'unset'
        this.showInfo = true
      }
    })

    gsap.to(this.title, 0.5, {
      ease: 'power3.out',
      color: '#fff'
    })

    gsap.to(this.children, 0.75, {
      y: '0%',
      delay: 0.25,
      opacity: 1,
      stagger: 0.1,
      ease: 'expo.out',
      onStart: () => {
        gsap.set(this.children, { willChange: 'transform' })
      },
      onComplete: () => {
        gsap.set(this.children, { willChange: 'unset' })
      }
    })

    Hover.setActiveHover(this);
  }

  leave = () => {
    gsap.to(this.overlay, 0.5, {
      y: '100%',
      ease: 'expo.out',
      opacity: 0,
      onStart: () => {
        this.overlay.style.willChange = 'transform'
      },
      onComplete: () => {
        this.overlay.style.willChange = 'unset'
        this.showInfo = false
      }
    })

    gsap.to(this.title, 0.5, {
      ease: 'power3.out',
      color: '#000'
    })

    gsap.to(this.children, 0.5, {
      y: '33px',
      opacity: 0,
      onStart: () => {
        gsap.set(this.children, { willChange: 'transform' })
      },
      onComplete: () => {
        gsap.set(this.children, { willChange: 'unset' })
      }
    })

    Hover.setActiveHover(null);
  }

  bind () {
    if (this.noTouch) {
      if (this.showInfo) {
        this.member.addEventListener('click', this.leave)
      } else {
        this.member.addEventListener('click', this.enter)
      }
    } else {
      this.member.addEventListener('mouseenter', this.enter)
      this.member.addEventListener('mouseleave', this.leave)
    }
  }
}
